// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"6527":"7204cca3","6891":"29c52701"}[chunkId] + ".css";
};